module.exports = __webpack_public_path__ + "images/equipment_head_3.2cfd2a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/equipment_head_3.png
// module id = 205
// module chunks = 33